
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  data() {
    return {
      dialog: false,
      btnText: "Ok",
      content: "",
      title: "",
      callbackOnClose: null
    };
  },
  created() {
    this.$nuxt.$on("show-info-dialog", this.openInfoDialog);
  },
  mounted() {},
  methods: {
    openInfoDialog(data) {
      this.dialog = true;
      this.btnText = data.btnText || this.btnText;
      this.content = data.content;
      this.title = data.title;
      this.callbackOnClose = data.callbackOnClose || null;
    },
    handleButtonClick() {
      this.dialog = false;

      // Call the  callback if it's defined
      if (this.callbackOnClose) {
        this.callbackOnClose();
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("show-info-dialog");
  }
};
